import { render, staticRenderFns } from "./wallet-withdrawal-history.vue?vue&type=template&id=4478a1e6"
import script from "./wallet-withdrawal-history.vue?vue&type=script&lang=js"
export * from "./wallet-withdrawal-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports